export default __webpack_public_path__ + "static/wsg-gb-2018-dd31130fdfccdd5f8bf93bd264e7cd61.jpg";